module.exports = __webpack_public_path__ + "static/media/icon-arrow.dfbbe903.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-arrow.svg
// module id = ./src/assets/images/icon-arrow.svg
// module chunks = 0